<script>
/**
 * Type         : Biz component
 * Title        : 화물검색 컴포넌트
 * Description  : 화물 검색을 위한 컴포넌트
 *
 ************ 검색조건 ************
 * 탭 배송업체정보
 * - 배송업체 : 택배사 목록에서 선택
 * - 송장번호 : 여러 건 입력 시 공백으로 구분
 * 탭 받는 사람정보
 * - 국가코드 / 연락처 / 이메일 / 받는 사람 이름
 * 탭 회원정보
 * - 회원명, 회원ID
 * 공통
 * - 오더번호 / HBL / MBL : 다건 입력 시 공백 → 콤마 처리
 * - 출발/도착지 필터, 배송방법, 상태코드, 조회기간(from~to)
 *
 */

import ModalCustomerSearch from "@/components/admin/common/modal/CustomerSearch.vue"

export default {
  name: "Biz-parcel-lookup-form-by-parcel",
  emits:[
    'lookup-opt-sync',
    'lookup-parcel'
  ],
  // 택배사 목록 변경 감지
  watch: {
    "$store.getters.getCourierList"(val) {
      this.courierList = val
    },
  },
  computed:{
    parcelLocationList(){
      return this.$store.getters.getParcelLocationListImport
    },
    shippingList(){
      return this.$store.getters.getFreightMethodList
    },
    advancedFilterItems(){
      const orderStatusOptions = this.$store.getters.getOrderStatusCodeList || []
      const partnerOptions = this.$store.getters.getPartnerList || []
      const selectedStatusCodes = Array.isArray(this.statusCode) ? this.statusCode : []
      const items = selectedStatusCodes.map((value) => {
        const option = orderStatusOptions.find((item) => item.value === value)
        return option?.label || value
      })

      if (this.consoleFilter) {
        items.push(this.consoleFilter === "Y" ? "콘솔" : "비콘솔")
      }

      if (this.tempConsolStatus) {
        const option = this.tempConsolStatusOptions.find((item) => item.value === this.tempConsolStatus)
        items.push(`콘솔상태: ${option?.label || this.tempConsolStatus}`)
      }

      if (this.packingStatus) {
        items.push("포장완료")
      }

      if (this.partnerId) {
        const option = partnerOptions.find((item) => item.value === this.partnerId)
        items.push(`파트너: ${option?.label || this.partnerId}`)
      }

      return items
    }
  },
  components: {
    ModalCustomerSearch,
  },
  data() {
    return {
      authLevel         : '00',

      courierList       : this.$store.getters.getCourierList,
      byParcel          : true,
      byReceiver        : false,
      byMember          : false,

      // 받는 사람정보로 조회
      mobileCountry     : "",
      mobileNum         : "",
      customerEmail     : "",
      receiver          : "",

      // 배송업체정보로 조회
      courierCode       : "",
      courierNum        : "",

      // 회원정보로 조회
      customerName      : "",
      customerId        : "",

      statusCode        : [], // 오더 상태 코드 목록
      orderNum          : "", // 오더번호
      hblNo             : "", // hblNo
      mblNo             : "", // mblNo
      consoleFilter     : "",
      consoleFilterOptions: [
        { label: "전체", value: "" },
        { label: "비콘솔", value: "N" },
        { label: "콘솔", value: "Y" },
      ],
      tempConsolStatus  : "",
      tempConsolStatusOptions: [
        { label: "전체", value: "" },
        { label: "미등록", value: "NONE" },
        { label: "연결대기", value: "READY" },
        { label: "연결완료", value: "LINKED" },
      ],
      packingStatus     : "",
      packingStatusOptions: [
        { label: "전체", value: "" },
        { label: "포장완료", value: "COMPLETED" },
      ],

      // filteredLocation  : [], // 화물위치 필터
      // shippingMethod    : [], // 운송수단 필터

      // 날짜 선택
      startDate     : "",
      endDate       : "",
      datepicker    : {
        from  : "",
        to    : ""
      },
      proxyDate     : {
        from  : "",
        to    : ""
      },
      startDatePopup : false,
      endDatePopup   : false,

      // 고객검색 모달
      modifyModalShow   : false,
      tab               : "order-info",

      partnerId         : "",
    }
  },

  methods:{

    syncDateRange () {
      if (this.startDate && this.endDate && this.startDate > this.endDate) {
        const temp = this.startDate
        this.startDate = this.endDate
        this.endDate = temp
      }

      this.proxyDate = {
        from: this.startDate,
        to: this.endDate
      }
      this.datepicker = {
        from: this.startDate,
        to: this.endDate
      }
      this.lookupOptSync()
    },

    saveStartDate () {
      this.startDatePopup = false
      this.syncDateRange()
    },

    saveEndDate () {
      this.endDatePopup = false
      this.syncDateRange()
    },

    getDateMonthsAgo(months) {
      const date = new Date()
      date.setMonth(date.getMonth() - months)
      return this.formatDate(date)
    },

    formatDate(date) {
      const year = date.getFullYear()
      const month = this.lPad(date.getMonth() + 1, 2)
      const day = this.lPad(date.getDate(), 2)
      return `${year}-${month}-${day}`
    },

    setQuickRange(months) {
      this.startDate = this.getDateMonthsAgo(months)
      this.endDate = this.getToday()
      this.syncDateRange()
    },

    /**
     * Title        : 검색 카테고리 탭 토글
     * Status       : Actived
     * Description  : 화물 검색을 위해 분류되어 있는 카테고리 탭
     * @param {Number} res - 1: 배송업체정보, 2: 받는 사람정보, 3: 회원정보
     */
    tabToggle(res){
      if(res === 1){
        this.byParcel       = true
        this.byReceiver     = false
        this.byMember       = false
      } else if(res === 2){
        this.byParcel       = false
        this.byReceiver     = true
        this.byMember       = false
      } else if(res === 3){
        this.byParcel       = false
        this.byReceiver     = false
        this.byMember       = true
      } else if(res === 4){
        this.byParcel       = false
        this.byReceiver     = false
        this.byMember       = true
      } else if(res === 5){
        this.byParcel       = false
        this.byReceiver     = false
        this.byMember       = true
      } else if(res === 6){
        this.byParcel       = false
        this.byReceiver     = false
        this.byMember       = true
      }

      this.courierCode      = ""
      this.courierNum       = ""

      this.mobileCountry    = ""
      this.mobileNum        = ""
      this.customerEmail    = ""
      this.receiver         = ""

      this.customerName     = ""
      this.customerId       = ""

      this.orderNum         = ""
      this.hblNo            = ""
      this.mblNo            = ""

      // 검색조건 초기화 후 동기화
      this.lookupOptSync()
    },

    /**
     * Title        : 검색조건 동기화
     * Status       : Actived
     * Description  : 화물 검색을 위한 조건을 parents에 전달한다.
     */
    lookupOptSync(){
      this.$log.debug("[ Parcel lookup form / lookupOptSync ]")

      // 검색조건을 동기화한다.
      let opt = {
        courierCode       : this.courierCode,
        courierNum        : this.courierNum,

        mobileCountry     : this.mobileCountry,
        mobileNum         : this.mobileNum,
        customerEmail     : this.customerEmail,
        receiver          : this.receiver,

        customerId        : this.customerId,

        orderNum          : this.orderNum && this.orderNum.length > 0 ? this.orderNum.trim().replace(/\s+/g, ',') : "",
        hblNo             : this.hblNo && this.hblNo.length > 0 ? this.hblNo.trim().replace(/\s+/g, ',') : "",
        mblNo             : this.mblNo && this.mblNo.length > 0 ? this.mblNo.trim().replace(/\s+/g, ',') : "",

        // filteredLocation  : this.filteredLocation,
        // shippingMethod    : this.shippingMethod,

        statusCode        : this.statusCode,
        proxyDate         : this.proxyDate,
        consoleFilter     : this.consoleFilter,
        tempConsolStatus  : this.tempConsolStatus,
        packingStatus     : this.packingStatus,
        partnerId         : this.partnerId,
      }

      this.$emit('lookup-opt-sync', opt)
    },

    /**
     * Title        : 검색 조건에 따른 화물검색을 실행
     * Status       : Actived
     * Description  : 검색 조건에 따른 화물검색 기능 실행
     */
    lookupParcel(){
      this.$emit('lookup-parcel')
    },

    resetAdvancedFilters(){
      this.statusCode = []
      this.consoleFilter = ""
      this.tempConsolStatus = ""
      this.packingStatus = ""
      this.partnerId = ""
      this.lookupOptSync()
    },

    /**
     * Title        : 검색조건 - 고객변경
     * Status       : Actived
     * Description  : 검색조건의 고객을 변경한다.
     */
    changeCustomer(param){
      this.$log.debug("고객변경", param)

      this.customerName   = param.name
      this.customerId     = param.id
    },

    /**
     * Title        : 고객찾기 모달 실행
     * Status       : Actived
     * Description  : -
     */
    customerSearch(){
      this.modifyModalShow = true
    },

    /**
     * Title        : 모달닫기
     * Status       : Actived
     * Description  : -
     */
    closeModalSearch(){
      this.modifyModalShow = false
      this.lookupOptSync()
    },

    /**
     * Title        : 숫자 앞에 0을 채워서 길이를 맞춘다.
     * Status       : Actived
     * Description  : 숫자 앞에 0을 채워서 길이를 맞춘다.
     * @param {Number} num - 숫자
     * @param {Number} length - 길이
     */
    lPad(num, length) {
      this.$log.debug("[ Parcel lookup form / lPad ] num = ", num, ", length = ", length)

      // 숫자를 문자열로 변환하고, 길이가 length보다 작으면 앞에 0을 채운다.
      return String(num).padStart(length, '0')
    },

    /**
     * Title        : 캘린더 default 설정
     * Status       : Actived
     * Description  : 오늘 날짜 획득
     */
     getToday(){
      let today = new Date().toDateString()

      let newToday = new Date(today)

      let year  = newToday.getFullYear()    // 년
      let month = newToday.getMonth() + 1   // 월
      let day   = newToday.getDate()        // 일

      let result = year + "-" + this.lPad(month, 2) + "-" + this.lPad(day, 2)

      this.$log.debug("[ Parcel lookup form / getToday ] = ", result)

      return result
    },

    /**
     * Title        : 캘린더 default 설정
     * Status       : Actived
     * Description  : 일주일전 날짜 획득
     */
    getAWeekAgo(){
      let today = new Date().toDateString()

      let newToday = new Date(today)

      let year  = newToday.getFullYear()    // 년
      let month = newToday.getMonth() + 1   // 월
      let day   = newToday.getDate()        // 일

      let aWeekAgo = new Date(new Date().setDate(day - 7))

      let newAWeekAgo = new Date(aWeekAgo)

      year  = newAWeekAgo.getFullYear() // 년
      month = newAWeekAgo.getMonth() + 1  // 월
      day   = newAWeekAgo.getDate()      // 일

      let result = year + "-" + this.lPad(month, 2) + "-" + this.lPad(day, 2)

      this.$log.debug("[ Parcel lookup form / getAWeekAgo ] = ", result)

      return result
    },

    /**
     * Title        : 캘린더 default 설정
     * Status       : Actived
     * Description  : 캘린더의 일자를 기본설정으로 돌린다.
     */
    async initCalendar(){
      this.$log.debug("[ Parcel lookup form / initCalendar ]")

      const aWeekAgo  = this.getAWeekAgo()
      const today     = this.getToday()

      this.startDate = aWeekAgo
      this.endDate = today

      this.datepicker  = {
        from  : aWeekAgo,
        to    : today
      }

      this.proxyDate   = {
        from  : aWeekAgo,
        to    : today
      }
    },

    /**
     * Title        : 최초설정
     * Status       : Actived
     * Description  : 검색 조건 값을 default 한다.
     */
    async init(){
      this.$log.debug("[ Parcel lookup form / init ]")
      this.authLevel =  this.$getAuthLevel()

      await this.initCalendar()

      this.lookupOptSync()
    }
  },

  beforeMount(){
    // 오더상태 코드목록
    this.$getCodeList('ORDSTT')
  },

  mounted(){
    this.init()
  }
}
</script>

<template>
  <div class="comp-box parcel-lookup">
    <div class="row q-col-gutter-lg items-stretch">
      <div class="col-12 lookup-date-column">
        <div class="range-picker">
          <div class="lookup-section-title">조회기간</div>
          <div class="row q-col-gutter-sm items-start">
            <div class="col-12 col-sm-6">
              <q-input
                v-model="startDate"
                label="시작 날짜"
                outlined
                dense
                readonly>
                <template v-slot:append>
                  <q-btn flat round icon="event" color="primary">
                    <q-popup-proxy cover transition-show="scale" transition-hide="scale">
                      <q-date v-model="startDate" mask="YYYY-MM-DD">
                        <div class="row items-center justify-end q-gutter-sm">
                          <q-btn label="Cancel" color="primary" flat v-close-popup />
                          <q-btn label="OK" color="primary" flat @click="saveStartDate" v-close-popup />
                        </div>
                      </q-date>
                    </q-popup-proxy>
                  </q-btn>
                </template>
              </q-input>
            </div>

            <div class="col-12 col-sm-6">
              <q-input
                v-model="endDate"
                label="끝 날짜"
                outlined
                dense
                readonly>
                <template v-slot:append>
                  <q-btn flat round icon="event" color="primary">
                    <q-popup-proxy cover transition-show="scale" transition-hide="scale">
                      <q-date v-model="endDate" mask="YYYY-MM-DD">
                        <div class="row items-center justify-end q-gutter-sm">
                          <q-btn label="Cancel" color="primary" flat v-close-popup />
                          <q-btn label="OK" color="primary" flat @click="saveEndDate" v-close-popup />
                        </div>
                      </q-date>
                    </q-popup-proxy>
                  </q-btn>
                </template>
              </q-input>
            </div>
          </div>

          <div class="row q-col-gutter-sm q-mt-sm quick-range-buttons">
            <div class="col-auto">
              <q-btn outline dense color="primary" label="최근 1달" @click="setQuickRange(1)" />
            </div>
            <div class="col-auto">
              <q-btn outline dense color="primary" label="최근 3달" @click="setQuickRange(3)" />
            </div>
            <div class="col-auto">
              <q-btn outline dense color="primary" label="최근 6개월" @click="setQuickRange(6)" />
            </div>
            <div class="col-auto">
              <q-btn outline dense color="primary" label="최근 1년" @click="setQuickRange(12)" />
            </div>
          </div>

          <div class="text-caption text-grey q-mt-sm">
            {{ datepicker.from }} ~ {{ datepicker.to }}
          </div>
        </div>
      </div>

      <div class="col-12 lookup-search-column">
        <div class="search-panel">
          <div class="lookup-section-title">검색조건</div>
          <q-tabs
            v-model="tab"
            class="text-grey search-tabs"
            active-color="primary"
            indicator-color="primary"
            dense
            narrow-indicator>

            <q-tab
              name="order-info"
              @click="tabToggle(4)"
              label="Order정보" />

            <q-tab
              name="person-info"
              @click="tabToggle(2)"
              label="받는 사람정보" />

            <q-tab
              name="hbl-info"
              @click="tabToggle(5)"
              label="H/BL No." />

            <q-tab
              name="mbl-info"
              @click="tabToggle(6)"
              label="M/BL No." />
          </q-tabs>

          <q-separator />

          <q-tab-panels v-model="tab" animated class="search-panels">
            <q-tab-panel name="order-info" class="q-pa-sm">
              <q-input
                v-model="orderNum"
                @update:model-value="lookupOptSync"
                label="오더번호"
                outlined
                dense />
            </q-tab-panel>

            <q-tab-panel name="person-info" class="q-pa-sm">
              <div class="row q-col-gutter-sm">
                <div class="col-xs-12 col-sm-6">
                  <q-input
                    v-model="receiver"
                    @update:model-value="lookupOptSync"
                    label="받는 사람명"
                    placeholder="받는 사람명을 입력해주세요"
                    outlined
                    dense />
                </div>

                <div class="col-xs-12 col-sm-6">
                  <q-input
                    v-model="mobileNum"
                    @update:model-value="lookupOptSync"
                    @blur="this.$validMobile(mobileNum)"
                    label="전화번호"
                    placeholder="'-'을 제외한 전화번호를 입력해주세요"
                    outlined
                    dense />
                </div>
              </div>
            </q-tab-panel>

            <q-tab-panel name="hbl-info" class="q-pa-sm">
              <q-input
                v-model="hblNo"
                @update:model-value="lookupOptSync"
                label="H/BL No."
                outlined
                dense />
            </q-tab-panel>

            <q-tab-panel name="mbl-info" class="q-pa-sm">
              <q-input
                v-model="mblNo"
                @update:model-value="lookupOptSync"
                label="M/BL No."
                outlined
                dense />
            </q-tab-panel>
          </q-tab-panels>
        </div>
      </div>

      <div class="col-12">
        <q-separator class="lookup-divider" />
        <section class="advanced-filter" aria-labelledby="advanced-filter-title">
          <div class="advanced-filter-panel">
            <div class="advanced-filter-toolbar">
              <div id="advanced-filter-title" class="advanced-filter-title">
                <q-icon name="tune" size="20px" />
                <span>상세 조건</span>
              </div>
              <q-badge
                v-if="advancedFilterItems.length > 0"
                color="primary"
                :label="`적용 중 ${advancedFilterItems.length}개`" />
              <q-space />
              <q-btn
                flat
                dense
                no-caps
                icon="restart_alt"
                label="상세 조건 초기화"
                color="grey-7"
                :disable="advancedFilterItems.length === 0"
                @click="resetAdvancedFilters" />
            </div>

            <div class="advanced-filter-grid">
              <section class="advanced-filter-section advanced-filter-section--wide">
                <div class="advanced-filter-section__title">주문 처리 상태</div>
                <div class="order-status-options">
                  <q-checkbox
                    v-for="item in this.$store.getters.getOrderStatusCodeList"
                    :key="item.value"
                    v-model="statusCode"
                    :val="item.value"
                    :label="item.label"
                    color="primary"
                    dense
                    @update:modelValue="lookupOptSync" />
                </div>
              </section>

              <template v-if="Number(authLevel) >= 90">
                <section class="advanced-filter-section advanced-filter-section--console">
                  <div class="advanced-filter-section__title">콘솔 및 포장</div>
                  <div class="advanced-filter-control-grid">
                    <div class="advanced-filter-control">
                      <div class="advanced-filter-control__label">콘솔 구분</div>
                      <q-btn-toggle
                        class="advanced-filter-btn-group"
                        v-model="consoleFilter"
                        :options="consoleFilterOptions"
                        @update:modelValue="lookupOptSync"
                        color="white"
                        text-color="grey-8"
                        toggle-color="primary"
                        unelevated
                        dense
                        no-caps />
                    </div>

                    <div class="advanced-filter-control">
                      <div class="advanced-filter-control__label">콘솔 상태</div>
                      <q-btn-toggle
                        class="advanced-filter-btn-group"
                        v-model="tempConsolStatus"
                        :options="tempConsolStatusOptions"
                        @update:modelValue="lookupOptSync"
                        color="white"
                        text-color="grey-8"
                        toggle-color="primary"
                        unelevated
                        dense
                        no-caps />
                    </div>

                    <div class="advanced-filter-control">
                      <div class="advanced-filter-control__label">포장 상태</div>
                      <q-btn-toggle
                        class="advanced-filter-btn-group"
                        v-model="packingStatus"
                        :options="packingStatusOptions"
                        @update:modelValue="lookupOptSync"
                        color="white"
                        text-color="grey-8"
                        toggle-color="primary"
                        unelevated
                        dense
                        no-caps />
                    </div>
                  </div>
                </section>

                <section class="advanced-filter-section">
                  <div class="advanced-filter-section__title">파트너</div>
                  <q-select
                    v-model="partnerId"
                    :options="[{label: '전체', value: null}, ...$store.getters.getPartnerList]"
                    @update:modelValue="lookupOptSync"
                    label="파트너 선택"
                    outlined
                    dense
                    clearable
                    emit-value
                    map-options />
                </section>
              </template>
            </div>
          </div>
        </section>
      </div>

      <div class="col-12">
        <q-btn
          color="primary"
          size="lg"
          label="배송상품검색"
          class="full-width lookup-submit-btn"
          @click="lookupParcel"/>
      </div>
    </div>
  </div>

  <teleport to="body">
		<q-dialog
			v-model="modifyModalShow"
			persistent>
      <ModalCustomerSearch
        @change-customer="changeCustomer"
        @close-modal-search="closeModalSearch" />
    </q-dialog>

	</teleport>
</template>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.parcel-lookup {
  overflow: visible;
}

.lookup-section-title {
  margin-bottom: 10px;
  color: #183b56;
  font-size: 14px;
  font-weight: 700;
}

.lookup-date-column,
.lookup-search-column {
  width: 100%;
}

@media (min-width: 768px) {
  .lookup-date-column {
    flex: 0 0 39%;
    max-width: 39%;
    padding-right: 28px;
  }

  .lookup-search-column {
    flex: 0 0 61%;
    max-width: 61%;
    padding-left: 28px;
  }
}

.range-picker {
  height: 100%;
  padding: 4px 0;
}

.quick-range-buttons {
  justify-content: flex-start;
}

.search-panel {
  height: 100%;
  padding: 4px 0;
}

.search-tabs {
  justify-content: flex-start;
}

.search-panels {
  background: transparent;
}

.lookup-divider {
  margin: 2px 0 12px;
}

.advanced-filter {
  border: 1px solid #e4e9ee;
  border-radius: 8px;
  background: #fff;
}

.advanced-filter-panel {
  padding: 14px 16px 18px;
  background: #f8fafc;
}

.advanced-filter-toolbar {
  display: flex;
  align-items: center;
  min-height: 32px;
  margin-bottom: 10px;
}

.advanced-filter-title {
  display: flex;
  align-items: center;
  gap: 8px;
  color: #183b56;
  font-size: 14px;
  font-weight: 700;
}

.advanced-filter-grid {
  display: grid;
  grid-template-columns: minmax(0, 2fr) minmax(220px, 1fr);
  gap: 12px;
}

.advanced-filter-section {
  min-width: 0;
  padding: 14px;
  border: 1px solid #e4e9ee;
  border-radius: 8px;
  background: #fff;
}

.advanced-filter-section--wide {
  grid-column: 1 / -1;
}

.advanced-filter-section--console {
  min-width: 0;
}

.advanced-filter-section__title {
  margin-bottom: 10px;
  color: #183b56;
  font-size: 13px;
  font-weight: 700;
}

.advanced-filter-control-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 16px;
}

.advanced-filter-control {
  min-width: 0;
}

.advanced-filter-control__label {
  margin-bottom: 6px;
  color: #5f6b76;
  font-size: 12px;
  font-weight: 600;
}

.advanced-filter-btn-group {
  border: 1px solid #cfd8e3;
  border-radius: 4px;
  overflow: hidden;
}

.advanced-filter-btn-group :deep(.q-btn + .q-btn) {
  border-left: 1px solid #cfd8e3;
}

.order-status-options {
  display: flex;
  flex-wrap: wrap;
  gap: 8px 20px;
}

.lookup-submit-btn {
  min-height: 52px;
  font-weight: 700;
}

@media (max-width: 767px) {
  .advanced-filter-panel {
    padding: 10px 12px 14px;
  }

  .advanced-filter-grid,
  .advanced-filter-control-grid {
    grid-template-columns: 1fr;
  }

  .advanced-filter-section--wide {
    grid-column: auto;
  }

  .advanced-filter-control {
    overflow-x: auto;
  }
}

</style>
